import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["certifications", "empty"];
import React, { Fragment, useMemo } from "react";
import { formatDate } from "../../helpers";
export var Certifications = function Certifications(_ref) {
  var certifications = _ref.certifications,
      empty = _ref.empty,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var filteredCertifications = useMemo(function () {
    return certifications.filter(function (ed) {
      return !ed.omit;
    });
  }, [certifications]);
  if (!filteredCertifications.length && !empty) return null;
  return /*#__PURE__*/React.createElement("section", _extends({
    className: "certifications"
  }, otherProps), /*#__PURE__*/React.createElement("h2", null, "Certifications"), empty && /*#__PURE__*/React.createElement("p", null, "Click here to add your certifications"), /*#__PURE__*/React.createElement("dl", null, filteredCertifications.map(function (_ref2) {
    var certification = _ref2.certification,
        issuer = _ref2.issuer,
        date_issued = _ref2.date_issued,
        valid_until = _ref2.valid_until,
        description = _ref2.description,
        code = _ref2.code,
        info_url = _ref2.info_url,
        related_skills = _ref2.related_skills;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "".concat(certification, "/").concat(issuer, "/").concat(date_issued, "/").concat(code)
    }, false && /*#__PURE__*/React.createElement("dt", null, /*#__PURE__*/React.createElement("span", {
      "data-what": "certification"
    }, certification), /*#__PURE__*/React.createElement("span", {
      "data-what": "issuer"
    }, issuer)), /*#__PURE__*/React.createElement("dd", {
      className: "quiet"
    }, /*#__PURE__*/React.createElement("section", {
      className: "summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "certification-certification"
    }, certification), issuer && /*#__PURE__*/React.createElement("div", {
      className: "certification-issuer"
    }, issuer), date_issued && /*#__PURE__*/React.createElement("div", {
      className: "certification-date-issued"
    }, formatDate(date_issued)), valid_until && /*#__PURE__*/React.createElement("div", {
      className: "certification-valid-until"
    }, "Valid until ", formatDate(valid_until)), code && /*#__PURE__*/React.createElement("div", {
      className: "certification-code"
    }, /*#__PURE__*/React.createElement("strong", null, "Code:"), " ", code), info_url && /*#__PURE__*/React.createElement("div", {
      className: "certification-info-url"
    }, /*#__PURE__*/React.createElement("a", {
      href: info_url,
      target: "_blank",
      rel: "noreferrer noopener"
    }, "View information"))), /*#__PURE__*/React.createElement("section", {
      className: "details quick"
    }, /*#__PURE__*/React.createElement("p", null, description)), related_skills && related_skills.length !== 0 && /*#__PURE__*/React.createElement("section", {
      className: "related-skills"
    }, /*#__PURE__*/React.createElement("strong", null, "Related skills:"), " ", related_skills.join(", "))));
  })));
};